export const WEEK_DAYS = ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"];

export const toMinutes = (hhmm) => {
  if (!hhmm) return null;
  const [h, m] = hhmm.split(":").map(Number);
  return h * 60 + m;
};

// Duration + overnight flag for a shift, tolerant of shifts that cross midnight.
// "00:00" as an end time is treated as midnight (24:00), so 16:00 -> 00:00 = 8h.
export const shiftMeta = (start, end) => {
  const s = toMinutes(start);
  let e = toMinutes(end);
  if (s == null || e == null) return { hours: 0, overnight: false };
  if (e === 0) e = 1440;
  const overnight = e <= s;
  const dur = overnight ? e + 1440 - s : e - s;
  return { hours: +(dur / 60).toFixed(2), overnight };
};

// Default-tab days carry `enabled`, loop days carry `off`.
export const isDayOff = (day) => day?.off === true || day?.enabled === false;

export const totalHours = (days = []) =>
  days.reduce((sum, d) => (isDayOff(d) ? sum : sum + shiftMeta(d.start, d.end).hours), 0);
